export const FETCH_ENTERPRISE_DATA_REQUEST = 'FETCH_ENTERPRISE_DATA_REQUEST';
export const FETCH_ENTERPRISE_DATA_SUCCESS = 'FETCH_ENTERPRISE_DATA_SUCCESS';
export const FETCH_ENTERPRISE_DATA_FAILURE = 'FETCH_ENTERPRISE_DATA_FAILURE';
export const SAVE_ENTERPRISE_MESSAGE_REQUEST =
  'SAVE_ENTERPRISE_MESSAGE_REQUEST';
export const SAVE_ENTERPRISE_MESSAGE_SUCCESS =
  'SAVE_ENTERPRISE_MESSAGE_SUCCESS';
export const SAVE_ENTERPRISE_MESSAGE_FAILURE =
  'SAVE_ENTERPRISE_MESSAGE_FAILURE';
export const SAVE_ENTERPRISE_FESTIVITIES_REQUEST =
  'SAVE_ENTERPRISE_FESTIVITIES_REQUEST';
export const SAVE_ENTERPRISE_FESTIVITIES_SUCCESS =
  'SAVE_ENTERPRISE_FESTIVITIES_SUCCESS';
export const SAVE_ENTERPRISE_FESTIVITIES_FAILURE =
  'SAVE_ENTERPRISE_FESTIVITIES_FAILURE';
export const SAVE_ENTERPRISE_INFO_REQUEST = 'SAVE_ENTERPRISE_INFO_REQUEST';
export const SAVE_ENTERPRISE_INFO_SUCCESS = 'SAVE_ENTERPRISE_INFO_SUCCESS';
export const SAVE_ENTERPRISE_INFO_FAILURE = 'SAVE_ENTERPRISE_INFO_FAILURE';
export const SAVE_OPENING_REQUEST = 'SAVE_OPENING_REQUEST';
export const SAVE_OPENING_SUCCESS = 'SAVE_OPENING_SUCCESS';
export const SAVE_OPENING_FAILURE = 'SAVE_OPENING_FAILURE';
export const FETCH_VIRTUAL_OPERATOR_USERS_REQUEST =
  'FETCH_VIRTUAL_OPERATOR_USERS_REQUEST';
export const FETCH_VIRTUAL_OPERATOR_USERS_SUCCESS =
  'FETCH_VIRTUAL_OPERATOR_USERS_SUCCESS';
export const FETCH_VIRTUAL_OPERATOR_USERS_FAILURE =
  'FETCH_VIRTUAL_OPERATOR_USERS_FAILURE';
export const SAVE_VIRTUAL_OPERATOR_USER_REQUEST =
  'SAVE_VIRTUAL_OPERATOR_USER_REQUEST';
export const SAVE_VIRTUAL_OPERATOR_USER_SUCCESS =
  'SAVE_VIRTUAL_OPERATOR_USER_SUCCESS';
export const SAVE_VIRTUAL_OPERATOR_USER_FAILURE =
  'SAVE_VIRTUAL_OPERATOR_USER_FAILURE';
export const SAVE_VIRTUAL_OPERATOR_OFFICE_REQUEST =
  'SAVE_VIRTUAL_OPERATOR_OFFICE_REQUEST';
export const SAVE_VIRTUAL_OPERATOR_OFFICE_SUCCESS =
  'SAVE_VIRTUAL_OPERATOR_OFFICE_SUCCESS';
export const SAVE_VIRTUAL_OPERATOR_OFFICE_FAILURE =
  'SAVE_VIRTUAL_OPERATOR_OFFICE_FAILURE';
export const FETCH_VIRTUAL_OPERATOR_MESSAGES_REQUEST =
  'FETCH_VIRTUAL_OPERATOR_MESSAGES_REQUEST';
export const FETCH_VIRTUAL_OPERATOR_MESSAGES_SUCCESS =
  'FETCH_VIRTUAL_OPERATOR_MESSAGES_SUCCESS';
export const FETCH_VIRTUAL_OPERATOR_MESSAGES_FAILURE =
  'FETCH_VIRTUAL_OPERATOR_MESSAGES_FAILURE';
export const SAVE_VIRTUAL_OPERATOR_MESSAGE_REQUEST =
  'SAVE_VIRTUAL_OPERATOR_MESSAGE_REQUEST';
export const SAVE_VIRTUAL_OPERATOR_MESSAGE_SUCCESS =
  'SAVE_VIRTUAL_OPERATOR_MESSAGE_SUCCESS';
export const SAVE_VIRTUAL_OPERATOR_MESSAGE_FAILURE =
  'SAVE_VIRTUAL_OPERATOR_MESSAGE_FAILURE';
export const DELETE_VIRTUAL_OPERATOR_MESSAGE_REQUEST =
  'DELETE_VIRTUAL_OPERATOR_MESSAGE_REQUEST';
export const DELETE_VIRTUAL_OPERATOR_MESSAGE_SUCCESS =
  'DELETE_VIRTUAL_OPERATOR_MESSAGE_SUCCESS';
export const DELETE_VIRTUAL_OPERATOR_MESSAGE_FAILURE =
  'DELETE_VIRTUAL_OPERATOR_MESSAGE_FAILURE';
export const FETCH_VIRTUAL_OPERATOR_SETTINGS_REQUEST =
  'FETCH_VIRTUAL_OPERATOR_SETTINGS_REQUEST';
export const FETCH_VIRTUAL_OPERATOR_SETTINGS_SUCCESS =
  'FETCH_VIRTUAL_OPERATOR_SETTINGS_SUCCESS';
export const FETCH_VIRTUAL_OPERATOR_SETTINGS_FAILURE =
  'FETCH_VIRTUAL_OPERATOR_SETTINGS_FAILURE';
export const SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_REQUEST =
  'SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_REQUEST';
export const SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_SUCCESS =
  'SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_SUCCESS';
export const SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_FAILURE =
  'SAVE_VIRTUAL_OPERATOR_SETTINGS_FESTIVITIES_FAILURE';
export const SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_REQUEST =
  'SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_REQUEST';
export const SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_SUCCESS =
  'SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_SUCCESS';
export const SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_FAILURE =
  'SAVE_VIRTUAL_OPERATOR_SETTINGS_CLOSING_FAILURE';
export const FETCH_VIRTUAL_OPERATOR_STATISTICS_REQUEST =
  'FETCH_VIRTUAL_OPERATOR_STATISTICS_REQUEST';
export const FETCH_VIRTUAL_OPERATOR_STATISTICS_SUCCESS =
  'FETCH_VIRTUAL_OPERATOR_STATISTICS_SUCCESS';
export const FETCH_VIRTUAL_OPERATOR_STATISTICS_FAILURE =
  'FETCH_VIRTUAL_OPERATOR_STATISTICS_FAILURE';
export const FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_REQUEST =
  'FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_REQUEST';
export const FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_SUCCESS =
  'FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_SUCCESS';
export const FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_FAILURE =
  'FETCH_VIRTUAL_OPERATOR_CHAT_DETAILS_FAILURE';
export const SET_VIRTUAL_OPERATOR_STATISTICS_FILTER =
  'SET_VIRTUAL_OPERATOR_STATISTICS_FILTER';
export const FETCH_VIRTUAL_OPERATOR_MONITORING_REQUEST =
  'FETCH_VIRTUAL_OPERATOR_MONITORING_REQUEST';
export const FETCH_VIRTUAL_OPERATOR_MONITORING_SUCCESS =
  'FETCH_VIRTUAL_OPERATOR_MONITORING_SUCCESS';
export const FETCH_VIRTUAL_OPERATOR_MONITORING_FAILURE =
  'FETCH_VIRTUAL_OPERATOR_MONITORING_FAILURE';
export const FETCH_VIRTUAL_OPERATOR_COSTS_REQUEST =
  'FETCH_VIRTUAL_OPERATOR_COSTS_REQUEST';
export const FETCH_VIRTUAL_OPERATOR_COSTS_SUCCESS =
  'FETCH_VIRTUAL_OPERATOR_COSTS_SUCCESS';
export const FETCH_VIRTUAL_OPERATOR_COSTS_FAILURE =
  'FETCH_VIRTUAL_OPERATOR_COSTS_FAILURE';
export const FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_REQUEST =
  'FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_REQUEST';
export const FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_SUCCESS =
  'FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_SUCCESS';
export const FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_FAILURE =
  'FETCH_VIRTUAL_OPERATOR_AMBROGIO_COSTS_FAILURE';
export const FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_REQUEST =
  'FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_REQUEST';
export const FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_SUCCESS =
  'FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_SUCCESS';
export const FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_FAILURE =
  'FETCH_VIRTUAL_OPERATOR_AMBROGIO_PBXS_FAILURE';
export const SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_REQUEST =
  'SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_REQUEST';
export const SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_SUCCESS =
  'SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_SUCCESS';
export const SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_FAILURE =
  'SAVE_VIRTUAL_OPERATOR_NO_CREDIT_RULE_FAILURE';
export const SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_REQUEST =
  'SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_REQUEST';
export const SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_SUCCESS =
  'SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_SUCCESS';
export const SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_FAILURE =
  'SAVE_VIRTUAL_OPERATOR_TICKET_SETTINGS_FAILURE';